module.exports = __webpack_public_path__ + "img/illu_token_02.8978904e.svg";